import axios from 'axios'
import store from '@/store'
import {
  getToken
} from 'utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // withCredentials: true,
  timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  config.headers['bingotalk-language'] = store.getters.language;
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  config.headers['app'] = 'BingoTeacher'
  config.headers['appType'] = 'H5'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (+response.data.code === 901) {
      store().dispatch('LogOut')
      location.href = '/#/login'
      return false;
    } else {
      return response
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js